import { render, staticRenderFns } from "./Universities.vue?vue&type=template&id=a3190fe0&scoped=true&"
import script from "./Universities.vue?vue&type=script&lang=js&"
export * from "./Universities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3190fe0",
  null
  
)

export default component.exports